import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from '@cmps/ng-select';
import { CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsI18nModule } from '../i18n/i18n.module';
import { I18nService } from '../i18n/i18n.service';

import { ClientLogoComponent } from './client-logo.component';
import {
    FieldConfigInjectorDirective,
    SuperGroupSelectorComponent,
    ValidateOnBlurDirective,
    ValidationIndicatorDirective,
} from './common.form';
import { CmpsNgbDatePipe, CmpsSelectLabelPipe } from './common.pipe';
import { CanDeactivateService, CommonService } from './common.service';
import {
    RequiredWhenValidatorDirective,
    TextEqualValidatorDirective,
} from './common.validator';
import { CmpsDatePipe } from './date.pipe';
import { CmpsFormBuilder } from './experimental.form';
import { CmpsDecimalPipe, CmpsPercentPipe } from './number.pipe';
import { ScreenReaderLiveService } from './screen-reader-live.service';
import {
    ScreenReaderTableComponent,
    ScreenReaderTableSectionDirective,
} from './screen-reader-table.component';
import { WaitStatusComponent } from './wait-status.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SelectModule,
        CmpsI18nModule,
        CmpsIconModule,
    ],
    declarations: [
        CmpsNgbDatePipe,
        CmpsSelectLabelPipe,
        CmpsDatePipe,
        CmpsDecimalPipe,
        CmpsPercentPipe,
        FieldConfigInjectorDirective,
        ValidateOnBlurDirective,
        ValidationIndicatorDirective,
        RequiredWhenValidatorDirective,
        TextEqualValidatorDirective,
        SuperGroupSelectorComponent,
        WaitStatusComponent,
        ClientLogoComponent,
        ScreenReaderTableSectionDirective,
        ScreenReaderTableComponent,
    ],
    exports: [
        CmpsNgbDatePipe,
        CmpsSelectLabelPipe,
        CmpsDatePipe,
        CmpsDecimalPipe,
        CmpsPercentPipe,
        FieldConfigInjectorDirective,
        ValidateOnBlurDirective,
        ValidationIndicatorDirective,
        RequiredWhenValidatorDirective,
        TextEqualValidatorDirective,
        SuperGroupSelectorComponent,
        WaitStatusComponent,
        ClientLogoComponent,
        ScreenReaderTableSectionDirective,
        ScreenReaderTableComponent,
    ],
})
export class CmpsCommonModule {
    static forRoot(): ModuleWithProviders<CmpsCommonModule> {
        return {
            ngModule: CmpsCommonModule,
            providers: [
                CommonService,
                CanDeactivateService,
                ScreenReaderLiveService,
                CmpsFormBuilder,
                {
                    provide: CmpsDatePipe,
                    useClass: CmpsDatePipe,
                    deps: [I18nService],
                },
                {
                    provide: CmpsDecimalPipe,
                    useClass: CmpsDecimalPipe,
                    deps: [I18nService],
                },
                {
                    provide: CmpsPercentPipe,
                    useClass: CmpsPercentPipe,
                    deps: [I18nService],
                },
            ],
        };
    }
}
